<fc-general-modal
  [baseId]="baseId"
  [mode]="mode"
  [isSaveDisabled]="isDisabled"
  [form]="form"
  [listItemName]="listItemName"
  (saveForm)="onSave()"
  (cancelForm)="onCancel()"
>
  <div [formGroup]="form">
    <div class="date-picker">
      <ap-date-picker
        [baseId]="baseId"
        [maxDate]="mode === fcItemModalModeEnum.Modify && expirationDateControl.value"
        formControlName="EffectiveDate"
        labelName="Effective Date">
      </ap-date-picker>
    </div>


    <div class="date-picker">
      <ap-date-picker
        [baseId]="baseId"
        [minDate]="mode === fcItemModalModeEnum.Modify && effectiveDateControl?.value"
        formControlName="ExpirationDate"
        labelName="Expiration Date">
      </ap-date-picker>
    </div>
  </div>
</fc-general-modal>
